/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Contact_DescriptionInputs */

const he_seo_contact_description = /** @type {(inputs: Seo_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יש לכם שאלה או משוב על Pricedrop? צרו קשר ונחזור אליכם בהקדם.`)
};

const en_seo_contact_description = /** @type {(inputs: Seo_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a question or feedback about Pricedrop? Contact us and we will get back to you.`)
};

/**
* | output |
* | --- |
* | "Have a question or feedback about Pricedrop? Contact us and we will get back to you." |
*
* @param {Seo_Contact_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_contact_description = /** @type {((inputs?: Seo_Contact_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Contact_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_contact_description(inputs)
	return en_seo_contact_description(inputs)
});